<script>
import axios from '@/utils/axios';

const DEFAULT_FORM = () => ({
  id: null,
  name: '',
  date: '',
  branch_id: '',
  description: '',
});

export default {
  inject: ['setLoading'],
  emits: ['updated'],
  data() {
    return {
      form: DEFAULT_FORM(),
      errors: {},
      deleteItem: null,
      branches: [],
    };
  },
  mounted() {
    this.fetchBranches();
  },
  methods: {
    async fetchBranches() {
      try {
        const response = await axios.get('/branches');
        this.branches = response.data.data || [];
      } catch (error) {
        console.log(error.message);
      }
    },

    branchLabel(b) {
      return b.name || b.branch_name || b.title || `Branch #${b.id}`;
    },

    add() {
      this.resetForm();
    },

    edit(holiday) {
      this.resetForm();
      this.form.id = holiday.id;
      this.form.name = holiday.name || '';
      this.form.date = holiday.date || '';            // API "2026-10-12" = date input format
      this.form.branch_id = holiday.branch_id || '';  // null -> '' (All Branches)
      this.form.description = holiday.description || '';
    },

    setDelete(holiday) {
      this.deleteItem = holiday;
    },

    buildPayload() {
      return {
        name: this.form.name,
        date: this.form.date || null,
        branch_id: this.form.branch_id || null,  // '' -> null (All Branches)
        description: this.form.description || null,
      };
    },

    async save() {
      this.errors = {};
      this.setLoading(true);
      try {
        let response;
        if (this.form.id) {
          response = await axios.put(`/hrms/holidays/${this.form.id}`, this.buildPayload());
        } else {
          response = await axios.post('/hrms/holidays', this.buildPayload());
        }
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_holiday_modal');
        this.resetForm();
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async deleteHoliday() {
      this.setLoading(true);
      try {
        const response = await axios.delete(`/hrms/holidays/${this.deleteItem.id}`);
        this.$swalToast(response.data.message);
        this.$emit('updated');
        this.$closeModal('hrm_holiday_delete_modal');
      } catch (error) {
        if (error.type === 'validation') {
          this.$swalToast(error.errors?.id?.[0] || error.message, 'error');
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    resetForm() {
      this.form = DEFAULT_FORM();
      this.errors = {};
    },
  },
};
</script>

<template>
  <!-- Add/Edit Modal -->
  <div class="modal fade" id="hrm_holiday_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ form.id ? 'Edit' : 'Add' }} Holiday</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="save">
          <div class="modal-body pb-0">

            <!-- Name -->
            <div class="mb-3">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="form.name" placeholder="e.g. Diwali" />
              <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
            </div>

            <!-- Date -->
            <div class="mb-3">
              <label class="form-label">Date <span class="text-danger">*</span></label>
              <input type="date" class="form-control" v-model="form.date" />
              <div v-if="errors.date" class="text-danger small mt-1">{{ errors.date[0] }}</div>
            </div>

            <!-- Branch -->
            <div class="mb-3">
              <label class="form-label">Branch</label>
              <select class="form-select" v-model="form.branch_id">
                <option value="">All Branches</option>
                <option v-for="b in branches" :key="b.id" :value="b.id">{{ branchLabel(b) }}</option>
              </select>
              <div v-if="errors.branch_id" class="text-danger small mt-1">{{ errors.branch_id[0] }}</div>
            </div>

            <!-- Description -->
            <div class="mb-3">
              <label class="form-label">Description</label>
              <textarea class="form-control" rows="2" v-model="form.description" placeholder="Enter description (optional)"></textarea>
              <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary">{{ form.id ? 'Update' : 'Save' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="hrm_holiday_delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">You want to delete this holiday? This can't be undone.</p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteHoliday">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>